<template>
  <main style="margin:auto" :style="{ width: $vuetify.breakpoint.smAndDown ? '80vw' : '50vw' }">
    <h2 class="pb-3">Не удалось оплатить сессию подписания.</h2>
    <p>{{ failMessage }}</p>
    <v-btn tile dark color="rgb(0, 153, 51)" @click="backToEdit"  class="flex-grow-1">
      Вернуться назад
    </v-btn>
    <VSpin v-if="backToEditState" :value="backToEditState.isLoading"/>
  </main>
</template>
<script>
  import { useRouter } from '@/app/providers/router'
  import { useAsyncState } from '@/infranstructure/useAsyncState'
  import api from '@/utils/axios'
  import VSpin from '@/components/VSpin.vue'
  export default {
    name: 'PaymentFail',
    components: {
      VSpin,
    },
    data() {
      return {
        router: useRouter(),
        backToEditState: null,
      }
    },
    computed: {
      failMessage() {
        const failMessage = this.$route.query ? this.$route.query.failMessage : null
        return failMessage || ''
      },
      sessionId() {
        return this.$route.params.id
      },
      senderId() {
        return this.$route.params.uid
      },
    },
    beforeMount() {
      this.startUp()
    },
    methods: {
      startUp() {
        this.backToEditState = useAsyncState(() => this.backToEditFn(), null, { immediate: false })
      },
      async backToEditFn() {
        debugger
        await api.post(`/cancelPayment/${this.sessionId}`)
        this.router.toSigningPage({ sessionId: this.sessionId, senderId: this.senderId })
      },
      backToEdit() {
        debugger
        return this.backToEditState.execute()
      },
    },
  }
</script>
